import { render, staticRenderFns } from "./FigureHotspots.vue?vue&type=template&id=531f188b"
import script from "./FigureHotspots.vue?vue&type=script&lang=js"
export * from "./FigureHotspots.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports